import { render } from "./bandeaucachetb.vue?vue&type=template&id=a2f53efe&scoped=true"
import script from "./bandeaucachetb.vue?vue&type=script&lang=js"
export * from "./bandeaucachetb.vue?vue&type=script&lang=js"

import "./bandeaucachetb.vue?vue&type=style&index=0&id=a2f53efe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f53efe"]])

export default __exports__